function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'view-annotations-button-container': true,
          'active': $component.isAttributeEnabled(`active`)
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat("" + ($attr(`num-annotations`)) + "");;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;